<template>
  <v-row>
    <v-col cols="3">
       <v-list two-line subheader>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>First name</v-list-item-title>
        <v-list-item-subtitle>{{ doc.first }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>Last name</v-list-item-title>
        <v-list-item-subtitle>{{ doc.last }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>Email</v-list-item-title>
        <v-list-item-subtitle>{{ doc.email }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

     <v-list-item>
      <v-list-item-content>
        <v-list-item-title>Uid</v-list-item-title>
        <v-list-item-subtitle>{{ doc.uid }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    

    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>Initial</v-list-item-title>
        <v-list-item-subtitle>{{ doc.initial }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>Company</v-list-item-title>
        <v-list-item-subtitle>{{ doc.company }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>Role</v-list-item-title>
        <v-list-item-subtitle>{{ doc.role }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>Bio</v-list-item-title>
        <v-list-item-subtitle>{{ doc.bio }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

  </v-list>
    </v-col>
    <v-col cols="9">
        <h3 class="">Brand tile exercise</h3>
        <div class="pa-2">
          <tiles-viewer v-if="doc" :uid="doc.uid" />
        </div>
        <h3 class="mt-10">Functionality exercise</h3>
        <functionality-viewer v-if="doc" :uid="doc.uid" />
    </v-col>
  </v-row>

</template>

<script>
// @ is an alias to /src

import { mapState } from "vuex";
import TilesViewer from "@/components/exercises/TilesViewer";
import FunctionalityViewer from "@/components/exercises/FunctionalityViewer";

export default {
  name: "AdminUserShow",
  data() {
    return {
      doc: {},
      brandTileEx: null
    };
  },
  components: {
    TilesViewer,
    FunctionalityViewer
  },
  computed: {
    ...mapState(["userProfile", "currentUser", "tiles"]),
  },
  created() {
    const ref = this.$parent.collection.doc(this.$route.params.id);
    ref.get().then((doc) => {
      if (doc.exists) {
        this.doc = doc.data();
      } else {
        alert("No such document!");
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    const ref = this.$parent.collection.doc(to.params.id);
    ref.get().then((doc) => {
      if (doc.exists) {
        this.doc = doc.data();
        next();
      } else {
        alert("No such document!");
      }
    });
  }
};
</script>
